<div id={{dataId}}>
    <div class="p-text-center">

        <div class="spaces"></div>
        <div class="ui-g-12">
            <div class="ui-g-6" style="float:left">
                <img src="assets/images/logo2.png" alt="" height="90" />
                <p style="font-size: 10px;margin-top: 1px;margin-left:5px;">Atlanta, GA, USA</p>

            </div>
            <div class="ui-g-6" style="float:right">
                <p style="margin-right: 0%;"><b>Invoice No: </b> {{invoice_data.invoice_id}}
                    <br> <b>Date:</b> {{invoice_data.transactions[0].date | date:'medium'}}
                </p>

            </div>
        </div>
        <div class="spaces"></div>
        <div class="ui-g-12">
            <div class="ui-g-6" style="margin-right: 0%;">
                <h4><b>Invoice Details</b></h4>
                <p><b>Invoiced To:</b> {{invoice_data.invoice_to}} </p>
                <p><b>Email: </b> {{invoice_data.email}}</p>
                <p><b>Phone No.:</b> {{invoice_data.phone}}</p>
                <p><b>Address:</b> {{this.invoice_data.location.final_location }} </p>
            </div>
            <div class="ui-g-6">

                <h4><b>Payment Details</b></h4>
                <p><b>Paid by:</b> {{invoice_data.payment.paid_by}}</p>
                <p *ngIf="invoice_data.consultation_specialties!=''">
                    <b>Consultation Specialties:</b>{{invoice_data.consultation_specialties}}
                </p>

            </div>
        </div>
    </div>
    <div class="ui-g-12">
        <div class="ui-g-12">
            <div class="row p-text-center">
                <p-table [value]="invoice_data.transactions">
                    <ng-template pTemplate="header">
                        <tr>
                            <th><b>Sr. No.</b></th>
                            <th><b>Date</b></th>

                            <th><b>Description</b></th>
                            <th><b>Amount</b></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-transactions>
                        <tr>
                            <td>{{transactions.sr_no}}</td>
                            <td>{{transactions.date | date:'medium'}}</td>

                            <td>{{transactions.description}}</td>
                            <td style="text-align:right">{{transactions.amount}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <tr>
                            <td></td>
                            <td></td>
                            <td><b>Total</b></td>
                            <td style="text-align:right">{{invoice_data.total}}</td>
                        </tr>
                    </ng-template>
                </p-table>

            </div>
        </div>
    </div>
</div>